import React from "react";
import "./index.css";
import './tailwind.css';
import RouterPage from "./Router/Router";
import reportWebVitals from "./reportWebVitals";
import {BrowserRouter} from "react-router-dom";
import {createStore, applyMiddleware, compose} from "redux";
import {Provider} from "react-redux";
import {createLogger} from "redux-logger";
import thunk from "redux-thunk";
import "es6-shim";

import AllReducers from "./reducers";
import {createRoot} from "react-dom/client";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const middleware = [];
if (process.env.NODE_ENV !== "production") {
    middleware.push(createLogger());
}

const store = createStore(
    AllReducers,
    composeEnhancers(applyMiddleware(thunk))
);

const root = createRoot(document.getElementById("root"));
root.render(
    <BrowserRouter>
        <Provider store={store}>
            <RouterPage/>
        </Provider>
    </BrowserRouter>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
